"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMockMultipleChoiceOptions = exports.mockMultipleChoiceOptions = void 0;
exports.mockMultipleChoiceOptions = [
    { description: 'Option 1', id: '1', status: 'CORRECT' },
    { description: 'Option 2', id: '2', status: 'INCORRECT' },
    { description: 'Option 3', id: '3', status: 'INCORRECT' },
];
var getMockMultipleChoiceOptions = function () { return __spreadArray([], exports.mockMultipleChoiceOptions, true); };
exports.getMockMultipleChoiceOptions = getMockMultipleChoiceOptions;
